import { useState, useEffect } from "react";

const useIntersection = (element: any, rootMargin: string) => {
  const [isVisible, setState] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setState(entry.isIntersecting);
      },
      { rootMargin },
    );
    const currentElement = element.current;

    currentElement && observer.observe(currentElement);

    return () => {
      currentElement && observer.unobserve(currentElement);
    };
  }, [element, rootMargin]);

  return isVisible;
};
export default useIntersection;
